import firebase from "config/firebase";
import { toast } from "react-toastify";

export const fansRequest = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: "FANS_REQUEST_SKYPE",
    });
    firebase
      .firestore()
      .collection("fan_requests")
      .add(obj)
      .then((res) => {
        dispatch({
          type: "FANS_REQUEST_SKYPE_END",
        });
        toast.success("Request Submitted Successfully");
      })
      .catch((error) => {
        dispatch({
          type: "FANS_REQUEST_SKYPE_END",
        });
        toast.warning(error.message);
      });
  };
};

//GEt Fans Action
export const getFans = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "fan")
      .onSnapshot((query) => {
        var fans = [];
        query.forEach((doc) => {
          fans.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_FANS",
          payload: fans,
        });
      });
  };
};

export const getFanRequests = (fan_id, lastDocument, onComplete) => {
  return async (dispatch) => {
    try {
      let hasMoreDocument = false;
      let temp_data = [];
      let query = firebase
        .firestore()
        .collection("fan_requests")
        .where("fan_id", "==", fan_id)
        .orderBy("created_at", "desc")
        .limit(5);
      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }
      const querySnapshot = await query.get();
      const docs = querySnapshot.docs;
      if (querySnapshot.empty) {
        toast.warning("No Requests Found");
        onComplete();
      } else {
        for (const doc of docs) {
          const docData = doc.data();
          const athleteQuery = await firebase
            .firestore()
            .collection("users")
            .doc(docData.athlete_id)
            .get();
          const athleteData = athleteQuery.data();
          temp_data.push({
            id: doc.id,
            ...docData,
            athlete_name: `${athleteData.first_name} ${athleteData.last_name}`,
          });
        }
        onComplete();
      }
      hasMoreDocument = docs.length >= 5;
      const payload = {
        data: temp_data,
        hasMoreDocument: hasMoreDocument,
        lastDocument: docs.length > 0 ? docs[docs.length - 1] : null,
      };

      if (!lastDocument) {
        dispatch({ type: "GET_FAN_REQUESTS", payload });
      } else {
        dispatch({ type: "GET_FAN_REQUESTS_LOADMORE", payload });
      }
    } catch (error) {
      onComplete();
    }
  };
};

export const licensePurchase = ({ obj, onSuccess }) => {
  return async (dispatch) => {
    let newObj = {
      fanId: obj.fan_id,
      athleteId: obj.athlete_id,
      createdAt: obj.created_at,
      type: "Endorsement",
      isRead: [],
    };
    dispatch({
      type: "LICENSE_PURCHASE",
    });
    firebase
      .firestore()
      .collection("license_purchases")
      .add(obj)
      .then((res) => {
        firebase.firestore().collection("notification").add(newObj);
        dispatch({
          type: "LICENSE_PURCHASE_END",
        });
        dispatch({
          type: "REDIRECT_TRUE",
        });

        dispatch({
          type: "REDIRECT_FALSE",
        });
        onSuccess();
      })
      .catch((error) => {
        dispatch({
          type: "LICENSE_PURCHASE_END",
        });
        toast.warning(error.message);
      });
  };
};
export const licenseSubscription = ({ obj, onSuccess }) => {
  return async (dispatch) => {
    dispatch({
      type: "LICENSE_PURCHASE",
    });
    firebase
      .firestore()
      .collection("license_subscriptions")
      .add(obj)
      .then((res) => {
        dispatch({
          type: "LICENSE_PURCHASE_END",
        });
        onSuccess();
      })
      .catch((error) => {
        dispatch({
          type: "LICENSE_PURCHASE_END",
        });
        toast.warning(error.message);
      });
  };
};
export const getLicense = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .where("athlete_id", "==", id)
      .onSnapshot((query) => {
        var license = [];
        query.forEach((doc) => {
          license.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_LICENSE",
          payload: license,
        });
      });
  };
};
export const getAthleteName = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("athleteID", "==", Number(id))
      .onSnapshot((query) => {
        var athlete = [];
        query.forEach((doc) => {
          athlete.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_ATHLETE_NAME",
          payload: athlete,
        });
      });
  };
};

export const getSingleLicense = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .doc(id)
      .get()
      .then((res) => {
        let obj = { ...res.data(), id: id };
        dispatch({
          type: "GET_SINGLE_LICENSE",
          payload: obj,
        });
      });
  };
};

export const getSingleLicenseSubscriptions = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_subscriptions")
      .doc(id)
      .get()
      .then((res) => {
        let obj = { ...res.data(), id: id };
        dispatch({
          type: "GET_SINGLE_LICENSE_SUBSCRIPTIONS",
          payload: obj,
        });
      });
  };
};

export const verifyLicense = (id) => {
  return async (dispatch) => {
    dispatch(verifyLicenseLoader(true));
    await firebase
      .firestore()
      .collection("license_purchases")
      .doc(id)
      .get()
      .then((res) => {
        dispatch(verifyLicenseLoader(false));
        dispatch({
          type: "VERIFY_LICENSE",
          payload: res.data(),
        });
      });
  };
};

export const verifyLicenseLoader = (val) => async (dispatch) => {
  dispatch({
    type: "VERIFY_LICENSE_LOADER",
    payload: val,
  });
};

export const getMyLicenses = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_purchases")
      .where("fan_id", "==", id)
      .orderBy("created_at", "desc")
      .onSnapshot((query) => {
        var license = [];
        query.forEach((doc) => {
          license.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_MY_LICENSE",
          payload: license,
        });
      });
  };
};

export const getMyLicensesSubscriptions = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("license_subscriptions")
      .where("fan_id", "==", id)
      .orderBy("created_at", "desc")
      .onSnapshot((query) => {
        var license = [];
        query.forEach((doc) => {
          license.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_MY_LICENSE_SUBSCRIPTIONS",
          payload: license,
        });
      });
  };
};

export const updateDownload = (id) => async (dispatch) => {
  const response = await firebase
    .firestore()
    .collection("license_purchases")
    .doc(id)
    .get();
  if (!response.data().downloads) {
    firebase
      .firestore()
      .collection("license_purchases")
      .doc(id)
      .update({ downloads: 1 });
    dispatch(getSingleLicense(id));
  } else {
    firebase
      .firestore()
      .collection("license_purchases")
      .doc(id)
      .update({ downloads: Number(response.data().downloads) + 1 });
    dispatch(getSingleLicense(id));
  }
};

export const createComplaint = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: "GENERATE_COMPLAINT",
    });
    firebase
      .firestore()
      .collection("complaints")
      .add(obj)
      .then(async (res) => {
        const newDocId = res.id;
        const notificationData = {
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          type: "fan-issue",
          notifyID: newDocId,
          status: false,
        };
        await firebase
          .firestore()
          .collection("admin_notifiaction")
          .add(notificationData);
        dispatch({
          type: "GENERATE_COMPLAINT_END",
        });
        toast.success("Issue Submitted Successfully");
      })
      .catch((err) => {
        dispatch({
          type: "GENERATE_COMPLAINT_END",
        });
        toast.warning(err.message);
      });
  };
};

export const getIssues = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("complaints")
      .where("issue_by", "==", id)
      .onSnapshot((query) => {
        var requests = [];
        query.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_FAN_ISSUES",
          payload: requests,
        });
      });
  };
};

export const deleteIssue = (id) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("complaints")
      .doc(id)
      .delete()
      .then(toast.success("Issue Deleted Successfully"));
  };
};

export const updateComplaint = (data, id) => async (dispatch) => {
  await dispatch(updateComplaintloader(true));
  await firebase
    .firestore()
    .collection("complaints")
    .doc(id)
    .update(data)
    .then((res) => {
      dispatch(updateComplaintloader(false));
      alert("Issues update successfully");
    });
  dispatch(updateComplaintloader(false));
};

export const updateComplaintloader = (data) => (dispatch) => {
  dispatch({
    type: "UPDATEComplaintLOADER",
    payload: data,
  });
};
